import { render, staticRenderFns } from "./FriendRequest.vue?vue&type=template&id=fa94cce4&scoped=true"
import script from "./FriendRequest.vue?vue&type=script&lang=js"
export * from "./FriendRequest.vue?vue&type=script&lang=js"
import style0 from "./FriendRequest.vue?vue&type=style&index=0&id=fa94cce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa94cce4",
  null
  
)

export default component.exports